import { IsNotEmpty, IsString } from 'class-validator';

export class RefreshAccessTokenResult {
  @IsString()
  @IsNotEmpty()
  accessToken: string;
}
